import { createUseStyles } from "react-jss";
import { colors } from "../../constants/colors";

const styles = createUseStyles({
  profilePageHeader: {
    padding: "0 0 26px 0"
  },
  title: {
    color: colors.lightBlack,
    fontWeight: "600",
    fontSize: "30px",
    lineHeight: "38px",
    marginBottom: 0
  },
});

export default styles;
